import { LinerSpecification } from "../../provisions/models/provision-models";
import { deleteRequest, getRequest, postRequest, putRequest, RequestDataType } from "../../../../services/api";
import { materialTypesData } from "../utils/liner-material-type-data";


// #region

export const getAllLinerMaterials = async () => {
    return (await getRequest("/materialLibrary") || []) as LinerSpecification[];
}

export const getAllMaterialTypes = async () => {
    return materialTypesData;
}

export const postNewLinerMaterial = async (data: Omit<LinerSpecification, 'id'>) => 
    await postRequest("/materialLibrary", data, RequestDataType.Entity);

export const editLinerMaterial = async (data: LinerSpecification) => 
   await putRequest("/materialLibrary", data, RequestDataType.Entity);

export const deleteLinerMaterial = async (linerMaterialId: string) => 
    await deleteRequest("/materialLibrary", linerMaterialId);

// #endregion
